import { get as networkGet } from '../../networkClient';
import { Path } from '../path';

export async function getCommunityFees(clientId, communityId) {
  try {
    const response = await networkGet(
      Path.GET_FEES,
      { client_id: clientId, community_id: communityId, limit: 100 },
      null,
      true,
      true
    );

    return response?.data;
  } catch (error) {
    return {
      error: true,
      message: error.message,
      status: error.response?.status
    };
  }
}
